export default "__VITE_ASSET__CJUbhG0T__"